export default "__VITE_ASSET__D4zS2A5l__"